<script setup lang="ts">
/**
 * Bas de page des tunnels de don : pilule « Propulsé par Donoor » + liens
 * légaux Donoor (CGU + confidentialité).
 *
 * Avant (jusqu'au 2026-09-11) : le badge affichait le PSP qui encaisse
 * (« Propulsé par stripe » / « PayPal ») et les liens pointaient vers
 * stripe.com / paypal.com. Décision Karim : c'est Donoor qui propulse le
 * tunnel — la marque affichée est Donoor, et les conditions montrées sont
 * celles de Donoor.
 *
 * Le badge lui-même vit dans `DonatePoweredByDonoor`, partagé avec la page de
 * don personnalisée (`DonateCheckoutApp`).
 *
 * Il n'a plus AUCUN prop : le prop `providerLabel` a été retiré avec le PSP
 * qu'il décrivait, plutôt que laissé en coquille vide — un prop qui ne fait
 * plus rien réapparaît tôt ou tard dans un `:provider-label="…"` que personne
 * ne relit, et laisse croire que le bas de page suit encore le PSP.
 */
</script>

<template>
  <div class="mt-6 text-center text-sm text-gray-500">
    <DonatePoweredByDonoor show-legal-links />
  </div>
</template>
